<template>
  <div>
    <Mixed />
    <Crops />
  </div>
</template>

<script>
  import Mixed from '@/components/anychart/Mixed';
  import Crops from '@/components/anychart/Crops';

  export default {
    name: 'AnyChart',
    components: { Mixed, Crops }
  }
</script>

<style scoped>

</style>